// extracted by mini-css-extract-plugin
export var arrows = "_7g-6";
export var decrementer = "_7g-a";
export var disabled = "_7g-4";
export var error = "_7g-1";
export var hiddenText = "_7g-b";
export var incrementer = "_7g-9";
export var input = "_7g-8";
export var inputWrapper = "_7g-0";
export var leadingIcon = "_7g-c";
export var readonly = "_7g-3";
export var regular = "_7g-7";
export var small = "_7g-5";
export var warning = "_7g-2";